import { PrimitiveUnit } from "./unit.model";

export class DeliveryType extends PrimitiveUnit {
  short_name: string;
  active: boolean;
  operation_types: Array<any>;
}
